/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderFinishedInfos } from '../../models/production-order-finished-infos';

export interface GetFinishedInfos$Params {
  productionOrderId: number;
}

export function getFinishedInfos(http: HttpClient, rootUrl: string, params: GetFinishedInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderFinishedInfos>> {
  const rb = new RequestBuilder(rootUrl, getFinishedInfos.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderFinishedInfos>;
    })
  );
}

getFinishedInfos.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetFinishedInfos';
